import API from "../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";

// Get Performance Index Configuration
const getPerformanceConfig = createAsyncThunk(
  "performance/getConfigStatus",
  async () => {
    try {
      const { data: { data } } = await API.get("performance/getConfig");
      return data || null;
    } catch (error) {
      console.error("Error fetching performance config:", error);
      return null;
    }
  }
);

// Update Performance Index Configuration
const updatePerformanceConfig = async (configData) => {
  try {
    const data = await API.post("performance/updateConfig", configData);
    return data;
  } catch (error) {
    console.error("Error updating performance config:", error);
    return [];
  }
};

// Get Employee CTC for a year
const getEmployeeCTC = createAsyncThunk(
  "performance/getEmployeeCTCStatus",
  async (year) => {
    try {
      const { data: { data } } = await API.get(`performance/getEmployeeCTC/${year}`);
      return data || [];
    } catch (error) {
      console.error("Error fetching employee CTC:", error);
      return [];
    }
  }
);

// Update Employee CTC
const updateEmployeeCTC = async (ctcData) => {
  try {
    const data = await API.post("performance/updateEmployeeCTC", ctcData);
    return data;
  } catch (error) {
    console.error("Error updating employee CTC:", error);
    return [];
  }
};

// Get Performance Ratings for an employee (yearly - returns single object or null)
// Endpoint: GET /api/v1/performance/getPerformanceRatings/:employee_id/:year
const getPerformanceRatings = createAsyncThunk(
  "performance/getPerformanceRatingsStatus",
  async ({ employee_id, year }) => {
    try {
      const { data: { data } } = await API.get(`performance/getPerformanceRatings/${employee_id}/${year}`);
      // Returns single object or null (not array)
      return data || null;
    } catch (error) {
      console.error("Error fetching performance ratings:", error);
      return null;
    }
  }
);

// Save Performance Rating (yearly - direct fields, no month, no ratings array)
// Endpoint: POST /api/v1/performance/savePerformanceRating
// Payload: { employee_id, year, productivity, skills, communication, customer_support, initiatives, leadership, discipline }
const savePerformanceRating = async (ratingData) => {
  try {
    const data = await API.post("performance/savePerformanceRating", ratingData);
    return data;
  } catch (error) {
    console.error("Error saving performance rating:", error);
    return [];
  }
};

// Save All Performance Ratings (bulk save for an employee)
// Endpoint: POST /api/v1/performance/saveAllPerformanceRatings
// Note: This endpoint is kept for backward compatibility but now accepts yearly format
// Payload: { employee_id, year, productivity, skills, communication, customer_support, initiatives, leadership, discipline }
// (No longer accepts ratings array with month field - use savePerformanceRating instead)
const saveAllPerformanceRatings = async (ratingsData) => {
  try {
    const data = await API.post("performance/saveAllPerformanceRatings", ratingsData);
    return data;
  } catch (error) {
    console.error("Error saving all performance ratings:", error);
    return [];
  }
};

// Get All Performance Ratings for a year (yearly - no month field)
// Endpoint: GET /api/v1/performance/getAllPerformanceRatings/:year
const getAllPerformanceRatings = createAsyncThunk(
  "performance/getAllPerformanceRatingsStatus",
  async (year) => {
    try {
      const { data: { data } } = await API.get(`performance/getAllPerformanceRatings/${year}`);
      // Returns array of yearly ratings (no month field)
      return data || [];
    } catch (error) {
      console.error("Error fetching all performance ratings:", error);
      return [];
    }
  }
);

// Calculate Performance (triggers calculation for all employees)
const calculatePerformance = async (year) => {
  try {
    const data = await API.post(`performance/calculatePerformance/${year}`);
    return data;
  } catch (error) {
    console.error("Error calculating performance:", error);
    return [];
  }
};

// Get Performance Calculations for a year
const getPerformanceCalculations = createAsyncThunk(
  "performance/getPerformanceCalculationsStatus",
  async (year) => {
    try {
      const { data: { data } } = await API.get(`performance/getPerformanceCalculations/${year}`);
      return data || [];
    } catch (error) {
      console.error("Error fetching performance calculations:", error);
      return [];
    }
  }
);

export {
  getPerformanceConfig,
  updatePerformanceConfig,
  getEmployeeCTC,
  updateEmployeeCTC,
  getPerformanceRatings,
  savePerformanceRating,
  saveAllPerformanceRatings,
  getAllPerformanceRatings,
  calculatePerformance,
  getPerformanceCalculations,
};

